import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllReferenceMaterialsService = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    return axios.get(
      `${api}/ReferenceMaterial/GetReferenceMaterialGridData?pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${debouncedSearch}&sorting=`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const fetchReferenceMaterialByIdService = async (access_token, id) => {
  try {
    return axios.get(`${api}/ReferenceMaterial/GetReferenceMaterialById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const addReferenceMaterialService = async (access_token, formData, userName) => {
  try {
    return axios.post(`${api}/ReferenceMaterial/UploadReferenceMaterial?UserName=${userName}`, formData, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateReferenceMaterialService = async (access_token, formData, id) => {
  try {
    return axios.post(`${api}/ReferenceMaterial/EditReferenceMaterial?Id=${id}`, formData, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (err) {
    return err;
  }
};

export const deleteReferenceMaterialService = async (access_token, id) => {
  try {
    return axios.post(`${api}/ReferenceMaterial/Delete?referenceMaterialId=${id}`, {}, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchReferenceMaterialOnloadData = async (access_token, patientId, userId, cultureCode) => {
  try {
    const params = new URLSearchParams();
    if (patientId) params.append("PatientId", patientId);
    if (userId) params.append("UserId", userId);
    if (cultureCode) params.append("CurrentSiteUserCultureCode", cultureCode);

    return axios.get(`${api}/ReferenceMaterial/UploadReferenceMaterialOnload?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};
